var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./SectionContainer.css";

var SectionContainer = function (_Component) {
  _inherits(SectionContainer, _Component);

  function SectionContainer() {
    _classCallCheck(this, SectionContainer);

    return _possibleConstructorReturn(this, (SectionContainer.__proto__ || Object.getPrototypeOf(SectionContainer)).apply(this, arguments));
  }

  _createClass(SectionContainer, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: classNames(styles.root, this.props.className) },
        React.createElement(
          "div",
          { className: styles.header },
          this.props.header
        ),
        this.props.children
      );
    }
  }]);

  return SectionContainer;
}(Component);

SectionContainer.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  className: PropTypes.string
};

export default SectionContainer;


// WEBPACK FOOTER //
// ./src/components/Library/SectionContainer/SectionContainer.js